import { IDeviceTopicResponse } from '../dtos';

const deviceTopicsResponse: IDeviceTopicResponse[] = [
  {
    id: '3c7e1f0a-5b2d-4c8e-9a61-0d4f2b7e8c15',
    name: 'offers',
    englishName: 'Offers',
    arabicName: 'العروض',
    isSubscribed: true,
    canUnsubscribe: true
  },
  {
    id: '6b1d9e3f-2a7c-4f05-8e16-4c9a0b3d7f21',
    name: 'service-updates',
    englishName: 'Service updates',
    arabicName: 'تحديثات الخدمة',
    isSubscribed: true,
    canUnsubscribe: false
  }
];

export const deviceTopicsData = {
  deviceTopicsResponse
};
